import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  announcements: [],
  cities: [],
  type_announcement: 'v',
  profession: 'd',
  address: '',
  city: '',
  phone: '',
  comment: '',
  selected_city_num: 0,
  announcement_id: 0,
  hide_tab_bar: false,
};

export const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    setHideTabBar: (state, action) => {
      state.hide_tab_bar = action.payload;
    },
    setAnnouncementId: (state, action) => {
      state.announcement_id = action.payload;
    },
    setAnnouncements: (state, action) => {
      state.announcements = action.payload || [];
    },
    setCities: (state, action) => {
      state.cities = action.payload || [];
    },
    setCity: (state, action) => {
      state.city = action.payload;
    },
    setTypeAnnouncement: (state, action) => {
      state.type_announcement = action.payload;
    },
    setProfession: (state, action) => {
      state.profession = action.payload;
    },
    setAddress: (state, action) => {
      state.address = action.payload;
    },
    setPhone: (state, action) => {
      state.phone = action.payload;
    },
    setComment: (state, action) => {
      state.comment = action.payload;
    },
    setSelectedCityNum: (state, action) => {
      state.selected_city_num = action.payload;
    },
  },
});

export const {
  setCity,
  setHideTabBar,
  setAnnouncementId,
  setAnnouncements,
  setCities,
  setTypeAnnouncement,
  setProfession,
  setAddress,
  setPhone,
  setComment,
  setSelectedCityNum,
} = jobSlice.actions;

export const selectAnnouncements = (state) => state.job.announcements;
export const selectCities = (state) => state.job.cities;
export const selectProfession = (state) => state.job.profession;
export const selectAddress = (state) => state.job.address;
export const selectPhone = (state) => state.job.phone;
export const selectComment = (state) => state.job.comment;
export const selectSelectedCityNum = (state) => state.job.selected_city_num;
export const selectTypeAnnouncement = (state) => state.job.type_announcement;
export const selectAnnouncementId = (state) => state.job.announcement_id;
export const selectHideTabBar = (state) => state.job.hide_tab_bar;
export const selectCity = (state) => state.job.city;

export default jobSlice.reducer;


